module.exports = __webpack_public_path__ + "static/media/payments.0f9452af.png";